<template>
  <div class="notfound">
    <img src="@/assets/images/common/404.png" alt="">
    <p>Page Not Found</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.notfound {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;

  img {
    width: 300px;
  }

  p{
    font-size: 18px;
    color: #666;
    margin-top: 10px;
  }
}
</style>